import { Component } from '@angular/core';

@Component({
    selector: 'fc-backdrop',
    template: `
        <div class="backdrop">
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./backdrop.component.less'],
    standalone: false
})
export class BackdropComponent {}
